import { IdentityPageTranslations } from '../types';

export const translations: IdentityPageTranslations = {
  docTitle: 'Restauration de l’identité',
  pageTitle: 'Restauration de l’identité',
  featureList: [
    {
      // 'key' MUST BE the same as array index
      key: '0',
      heading: 'Vous avez reçu une alerte? Nous pouvons vous aider.',
      summary: [
        '<p>Si vos renseignements ont été repérés sur un site Web suspect ou si vous avez en main une enquête de dossier de',
        'crédit que vous ne reconnaissez pas, il est possible qu’il s’agisse d’un vol d’identité. Contactez nos spécialistes',
        'en restauration de l’identité pour vous aider à confirmer si vous en avez été victime ou non.</p>',

        '<p><span class="sr-only">Numéro de téléphone :</span>',
        '<a tabindex="0" href="tel:+1-866-327-3078" class="text-nowrap">1-866-327-3078</a></p>',

        '<p>Si vous êtes victime d’un vol d’identité, nos spécialistes en restauration de l’identité peuvent vous faire épargner',
        'temps, argent et stress en vous guidant à travers les étapes nécessaires afin de signaler une activité frauduleuse et de',
        'restaurer votre identité.</p>'
      ].join('\n')
    },
    {
      key: '1',
      heading: '',
      summary: [
        '<p>Choisissez parmi trois niveaux de service pour vous assurer d’obtenir la forme d’aide qui répond à vos besoins.</p>',       
        '<h2 class="feature-item-heading">Aide générale</h2>',
        '<p>Mettez à votre disposition les ressources et les conseils dont vous avez besoin pour éviter qu’on ne vole votre identité.</p>',
        '<h2 class="feature-item-heading">Rétablissement guidé</h2>',
        '<p>Nous vous jumellerons à un enquêteur des fraudes qui confirmera que votre identité a été volée, remplira tous les documents et fera un suivi tout au long du processus.</p>',
        '<h2 class="feature-item-heading">Rétablissement par procuration limitée</h2>',
        '<p>Nous collaborerons directement avec les créanciers, les bureaux du gouvernement et d’autres organismes en votre nom (si vous signez une procuration).</p>'
      ].join('\n')
    }
  ]
};
